module.exports = __webpack_public_path__ + "img/university_thumbnail-400x300.c1a642fb.jpg";